import { AppBundle } from './app-bundles';

const LOCAL_STORAGE_PREFIX = 'hydra-use-external-ui:';

export const APP_EXTERNAL_UI_URLS = {
  [AppBundle.Journeys]: 'https://cio-external-uis.s3.amazonaws.com/journeys/entrypoint.js',
  [AppBundle.DesignStudio]: 'https://cio-external-uis.s3.amazonaws.com/design-studio/entrypoint.js',
};

export function getAppExternalOverrides(): Record<AppBundle, boolean> {
  const localStorageExternalOverrides: Record<AppBundle, boolean> = Object.values(AppBundle).reduce(
    (accumulator, app) => ({ ...accumulator, [app]: false }),
    {} as Record<AppBundle, boolean>,
  );

  const apps = Object.values(AppBundle) as string[];
  for (const key in localStorage) {
    if (key.startsWith(LOCAL_STORAGE_PREFIX)) {
      const app = key.replace(LOCAL_STORAGE_PREFIX, '');
      if (apps.includes(app)) {
        localStorageExternalOverrides[app as AppBundle] = localStorage[key] === 'true';
      }
    }
  }

  return localStorageExternalOverrides;
}

export function setAppExternalOverride(app: AppBundle, enabled: boolean) {
  localStorage.setItem(`${LOCAL_STORAGE_PREFIX}${app}`, enabled.toString());
}
